import createReactComponent from '../createReactComponent';
export default createReactComponent('exposure-plus-1', 'IconExposurePlus1', [
  ['path', { d: 'M3 12h6', key: 'svg-0' }],
  ['path', { d: 'M6 9v6', key: 'svg-1' }],
  ['path', { d: 'M18 19v-14l-4 4', key: 'svg-2' }],
]);
